module.exports = __webpack_public_path__ + "static/img/f-step1.7d116566.png";